import { type IFetchParams } from "@/composables/useFetchWithPagination"
import { OverviewRepository } from "@/repositories/overview.repository"

export const OverviewService = {
  Get: (params: IFetchParams) => OverviewRepository.Get(params),
}
